import { render, staticRenderFns } from "./Pi3cktemplate.vue?vue&type=template&id=db6e97f6&scoped=true&"
import script from "./Pi3cktemplate.vue?vue&type=script&lang=js&"
export * from "./Pi3cktemplate.vue?vue&type=script&lang=js&"
import style0 from "./Pi3cktemplate.vue?vue&type=style&index=0&id=db6e97f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6e97f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
